export enum AdvertisementTypeEnum {
  LB1 = "lb1",
  IMU1 = "imu1",
  IMU2 = "imu2",
  PRESTITIAL = "prestitial",
  CATFISH = "catfish",
}

export type AdUnitProps = {
  rootClassName?: string;
  type: AdvertisementTypeEnum;
  slot: string;
  id?: string;
};

export type AdTargetingType<T = string | string[]> = {
  key: string;
  value: T;
};

export type CompanionAdUnitProps = AdUnitProps & {
  adSlotSize: googletag.GeneralSize | undefined;
  pageNumber: string;
};
